var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18595 1.7804V1.56873C5.18595 1.21905 4.93554 0.933716 4.63031 0.933716H2.77819C2.47221 0.933716 2.22255 1.21905 2.22255 1.56873V1.7804H0V3.47377H2.22255V3.68544C2.22255 4.03428 2.47221 4.32046 2.77819 4.32046H4.63031C4.93554 4.32046 5.18595 4.03428 5.18595 3.68544V3.47377H11.8536V1.7804H5.18595ZM2.9634 3.47377V1.7804H4.4451V3.47377H2.9634ZM9.63104 5.80216C9.63104 5.45332 9.38064 5.16714 9.07541 5.16714H7.22328C6.91805 5.16714 6.66764 5.45332 6.66764 5.80216V6.01383H0V7.7072H6.66764V7.91887C6.66764 8.2677 6.91805 8.55388 7.22328 8.55388H9.07541C9.38064 8.55388 9.63104 8.2677 9.63104 7.91887V7.7072H11.8536V6.01383H9.63104V5.80216ZM7.40849 7.7072V6.01383H8.89019V7.7072H7.40849ZM5.18595 10.0356C5.18595 9.68675 4.93554 9.40057 4.63031 9.40057H2.77819C2.47221 9.40057 2.22255 9.68675 2.22255 10.0356V10.2473H0V11.9406H2.22255V12.1523C2.22255 12.5011 2.47221 12.7873 2.77819 12.7873H4.63031C4.93554 12.7873 5.18595 12.5011 5.18595 12.1523V11.9406H11.8536V10.2473H5.18595V10.0356ZM2.9634 11.9406V10.2473H4.4451V11.9406H2.9634Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.498e66b6c78a616b50fdccba911e6bfa.svg";
export { ForwardRef as ReactComponent };